import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faStar } from '@fortawesome/free-solid-svg-icons'

const STARS = [0, 1, 2, 3, 4]

export function formatRating(rating) {
  const value = Number(rating)
  return Number.isFinite(value) ? value.toFixed(1).replace('.', ',') : null
}

// Cinco estrelas com preenchimento proporcional (4,6 = quatro cheias e 60% da quinta).
export default function StarRating({ value, count, size = 'sm' }) {
  const number = Math.min(5, Math.max(0, Number(value) || 0))
  const label = formatRating(number)
  const fill = `${(number / 5) * 100}%`

  return (
    <span className={`cp-stars cp-stars-${size}`}>
      <span className='cp-stars-track' role='img' aria-label={`Nota ${label} de 5`}>
        <span className='cp-stars-base' aria-hidden='true'>
          {STARS.map(i => <FontAwesomeIcon key={i} icon={faStar} />)}
        </span>
        <span className='cp-stars-fill' style={{ width: fill }} aria-hidden='true'>
          {STARS.map(i => <FontAwesomeIcon key={i} icon={faStar} />)}
        </span>
      </span>
      <strong className='cp-stars-value'>{label}</strong>
      {count !== undefined && <span className='cp-stars-count'>({count})</span>}
    </span>
  )
}
